<template>
  <div class="sidebar-container2">
    <!-- 菜单区域：占满中间剩余空间，内部可滚动 -->
    <div class="sidebar-menu-wrap">
      <el-menu
        style="font-size: 16px !important"
        mode="vertical"
        :default-active="id + ''"
        :unique-opened="true"
        active-text-color="#ffffff"
      >
        <header-sidebar-item
          v-for="menu in menuList"
          :key="menu.id"
          :index="menu.id"
          :id="menu.id"
          :name="menu.name"
          :item="menu"
          @change="change"
        />
      </el-menu>
    </div>

    <!-- 登录按钮：始终贴底 -->
    <div
      v-if="!token"
      class="fay el-submenu__title old-login"
      @click="back('/Login', 10)"
    >
      <img
        src="../assets/image/avatar.jpg"
        alt=""
        style="background-color: #fff"
      />
      登录
    </div>
    <div
      v-else
      class="fay el-submenu__title new-login"
      @click="back('/PersonalCenter')"
    >
      <img :src="img" alt="" style="background-color: #fff" />
      个人中心
    </div>
  </div>
</template>
<script>
import HeaderSidebarItem from "./HeaderSidebarItem.vue";

export default {
  name: "HeaderSidebar",
  components: { HeaderSidebarItem },
  props: {
    menuList: { type: Array, required: true },
    id: { type: Number, required: true },
    token: { type: String, required: true },
    img: { type: String, required: true },
  },
  methods: {
    change(item) {
      this.$emit("change", item);
    },
    back(i, idx) {
      this.$emit("drawerClose");
      this.$router.push(i);
    },
  },
};
</script>
<style lang="scss" scoped>
/* 容器：列向 flex，菜单区撑满，登录按钮贴底 */
.sidebar-container2 {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  /* 中间菜单区：唯一允许滚动的区域，避免嵌套滚动 */
  .sidebar-menu-wrap {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .el-menu {
    border: none;
    height: auto;
    width: 100% !important;
    font-size: 16px !important;
  }

  /* 父菜单（走进财达 这种） */
  .el-submenu__title {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    background-color: #c11226 !important;
    color: #fff !important;
    border-top: 1px solid #fff !important;
    padding: 0 20px !important;
    @media (max-width: 300px) {
      font-size: 14px !important;
    }
  }

  /* 父菜单展开后箭头方向 */
  .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
    transform: rotateZ(180deg);
  }

  /* 子菜单项（公司简介 这种） */
  .el-menu-item {
    height: 50px;
    line-height: 50px;
    background-color: #fff !important;
    color: #000 !important;
    font-size: 16px !important;
    min-width: 0;
    padding: 0 45px !important;
    @media (max-width: 300px) {
      font-size: 14px !important;
    }
  }

  /* 最后一个父菜单底部加横线分隔 */
  .el-submenu__title:last-child {
    border-bottom: 1px solid #fff !important;
  }

  /* 登录/个人中心 按钮 */
  .old-login,
  .new-login {
    flex: 0 0 auto;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color: #c11226 !important;
    color: #fff !important;
    border-top: 1px solid #fff !important;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #fff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/HeaderSideBar.vue